import { MonthlyTotals } from '../../types';

/**
 * Add monthly totals together
 */
export function addMonthlyTotals(a: MonthlyTotals, b: MonthlyTotals): MonthlyTotals {
  return {
    month1: a.month1 + b.month1,
    month2: a.month2 + b.month2,
    month3: a.month3 + b.month3,
    month4: a.month4 + b.month4,
    month5: a.month5 + b.month5,
    month6: a.month6 + b.month6,
    month7: a.month7 + b.month7,
    month8: a.month8 + b.month8,
    month9: a.month9 + b.month9,
    month10: a.month10 + b.month10,
    month11: a.month11 + b.month11,
    month12: a.month12 + b.month12,
  };
}

/**
 * Subtract monthly totals (a - b)
 */
export function subtractMonthlyTotals(a: MonthlyTotals, b: MonthlyTotals): MonthlyTotals {
  return {
    month1: a.month1 - b.month1,
    month2: a.month2 - b.month2,
    month3: a.month3 - b.month3,
    month4: a.month4 - b.month4,
    month5: a.month5 - b.month5,
    month6: a.month6 - b.month6,
    month7: a.month7 - b.month7,
    month8: a.month8 - b.month8,
    month9: a.month9 - b.month9,
    month10: a.month10 - b.month10,
    month11: a.month11 - b.month11,
    month12: a.month12 - b.month12,
  };
}

/**
 * Apply sign convention to account value
 *
 * DealerBuilt database sign convention:
 * - Credits (income/gross): stored as NEGATIVE in acline.amount
 * - Debits (expenses): stored as POSITIVE in acline.amount
 *
 * For INCOME categories (like Rental Income, Other Income):
 *   - Credit accounts: DB has negative, negate to show POSITIVE (income coming in)
 *
 * For EXPENSE categories (like Semi-Fixed, Fixed, Variable):
 *   - Debit accounts (normal expenses): DB has positive, show as-is (adds to expenses)
 *   - Credit accounts (contra-expenses like 008, 018): DB has NEGATIVE
 *     Keep negative so they display with (-) and subtract from the category total
 */
export function applySign(value: number, sign: 'credit' | 'debit', isIncomeCategory: boolean): number {
  if (sign === 'credit') {
    if (isIncomeCategory) {
      // Income category: DB stores credits as negative, negate to show positive
      return -value;
    } else {
      // Expense category: DB stores credits as negative, KEEP negative
      // This displays with (-) and subtracts from the category total
      return value;
    }
  }
  return value; // Debit accounts: use as-is (positive from DB)
}

/**
 * Format percentage for display
 */
export function formatPercent(value: number, gross: number): string {
  if (gross === 0) return '--';
  const percent = (value / gross) * 100;
  return `${percent.toFixed(1)}%`;
}

/**
 * Format per-unit currency for display
 */
export function formatPerUnit(value: number, units: number, formatCurrency: (v: number) => string): string {
  if (units === 0) return '--';
  const perUnit = value / units;
  return formatCurrency(perUnit);
}
